import { render, staticRenderFns } from "./suspected-ips.vue?vue&type=template&id=f1a969c2"
import script from "./suspected-ips.vue?vue&type=script&lang=js"
export * from "./suspected-ips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports